var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"q10__jumbotron relative"},[_c('hotspot-richmedia',{staticClass:"bottom-6 left-12",attrs:{"options":{
                icon: "diaporama",
                collection:  [
                    {
                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/img42.jpg",
                        "type": "image",
                        "caption": "RIZZANESE EN CORSE",
                        
                    }
                ] 
            }}}),_c('image-with-descriptions',{staticClass:"mb-8 mt-0 md:-mt-12",attrs:{"options":{
                image:
                    'pages/' +
                    _vm.currentPage.slug +
                    '/' +
                    _vm.currentPage.images.imageJumbotron.src,
                descriptions: [
                    {
                        text: _vm.currentPage.images.imageJumbotron.edf,
                        position: 'bottom-right', // top/bottom-left/right
                        orientation: 'horizontal', // vertical, horizontal
                    } ],
            }}})],1),_c('div',{staticClass:"page"},[_c('div',{staticClass:"container px-11 2xl:px-3 lg:px-3 mb-14 m-auto"},[_c('title-s-chapter',{attrs:{"options":{
                    from: 'from-resolution_blue',
                    to: 'to-line',
                }}},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.mainTitle.text)}})]),_c('p',{staticClass:"font-bold text-tundora text-xl mb-5",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.description.text)}}),_c('div',{staticClass:"container-components"},[_c('div',{staticClass:"card break-inside-avoid"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-resolution_blue',
                            to: 'to-line',
                        }}},[_c('p',{staticClass:"text-xl lg:text-2xl 2xl:text-4xl",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.firstTitle.text)}})]),_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-resolution_blue',
                            to: 'to-line',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                direction: 'top',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.firstSubTitle.text)}})],1)],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('div',[_c('span',{staticClass:"timeline-title__content text-lg text-nandor",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.firstParagraph.text)}})]),_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                                icon: "diaporama",
                                collection:  [
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/dev_28_29_retrospective_inauguration_romanche_gavet_9_octobre_2020.mp4",
                                        "type": "html5video",
                                        "caption": "Romanche Gavet - Epopée 2010-2020",
                                        "thumb": _vm.getSpecificURL() + "fr/images/thumbs/developpement_france_et_inter/resized_Retrospective_inauguration.png"
                                    },
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/new_img48.jpg",
                                        "type": "image",
                                        "caption": "Photo d’équipe : Romanche Gavet en en Isère",
                                        
                                    } ] 
                            }}}),_c('image-with-descriptions',{attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.image1.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.image1.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1),_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-resolution_blue',
                            to: 'to-line',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                direction: 'top',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.secondSubTitle.text)}})],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{staticClass:"timeline-title__content  text-lg text-nandor",domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.secondParagraph.text
                            )}})])],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                                icon: "diaporama",
                                collection:  [
                                {
                                    "src": _vm.getSpecificURL() + "fr/richmedia/page-012/dev_29_2016_romanche_gavet_ouvrages_restitution_et_dissipateurs.mp4", //H",
                                    "type": "html5video",
                                    "caption": "Romanche Gavet - Ouvrages de restitution et dissipateurs - 2016",
                                    
                                } ] 
                            }}}),_c('image-with-descriptions',{staticClass:"eliminate-margin",attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.image2.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.image2.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1),_c('p',{staticClass:"timeline-title__content text-lg ",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.thirdParagraph.text)}}),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{staticClass:"timeline-title__content text-lg text-nandor",domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.fourthParagraph.text
                            )}})])],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                                icon: "diaporama",
                                collection:  [
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/dev_30_31_2013_romanche_gavet_excavation_des_cavernes.mp4",
                                        "type": "html5video",
                                        "caption": "Romanche Gavet - Excavation des cavernes - 2013",
                                        "thumb": _vm.getSpecificURL() + "fr/images/thumbs/developpement_france_et_inter/resized_excavation_traditionnelle.png"
                                    },
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/dev_30_31_2016_romanche_gavet_24h_vie_du_tunnelier_3min.mp4",
                                        "type": "html5video",
                                        "caption": "Romanche Gavet - 24h vie du tunnelier - 2016",
                                        "thumb": _vm.getSpecificURL() + "fr/images/thumbs/developpement_france_et_inter/4.7_Romanche_Gavet_24h_vie_du_tunnelier_2016.jpg"
                                    } ] 
                            }}}),_c('div',[_c('image-with-descriptions',{attrs:{"options":{
                                    image:
                                        'pages/' +
                                        _vm.currentPage.slug +
                                        '/' +
                                        _vm.currentPage.images.image3.src,
                                    descriptions: [
                                        {
                                            text: _vm.currentPage.images.image3
                                                .edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        } ],
                                }}})],1),_c('TitleParagraph',{attrs:{"options":{
                                from: 'from-resolution_blue',
                                to: 'to-line',
                            }}},[_c('Triangles',{attrs:{"options":{
                                    colors: [
                                        '#00357f',
                                        '#0b4f9c',
                                        '#0d94ff' ],
                                    direction: 'top',
                                }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                    _vm.currentPage.content.thirdSubTitle.text
                                )}})],1)],1)]),_c('paragraph',{attrs:{"options":{
                        color: 'text-nandor',
                    }}},[_c('span',{staticClass:"timeline-title__content text-lg text-nandor",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.fifthParagraph.text)}})])],1),_c('div',{staticClass:"relative"},[_c('div',{staticClass:"\n                        container-timeline-title-si-image-with-description-second-2\n                        card\n                        relative\n                        mt-8\n                    "},[_c('div',{staticClass:"relative w-full h-full"},[_c('image-with-descriptions',{attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.image4.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.image4.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1),_c('div',{staticClass:"q10__textInImage_1"},[_c('h2',{staticClass:"q10__title",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.secondTitle.text)}})]),_c('div',{staticClass:"q10__textInImage_2"},[_c('p',{staticClass:"q10__paragraph text-lg",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sixthParagraph.text)}})])])]),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                        from: 'from-resolution_blue',
                        to: 'to-line',
                    }}},[_c('p',{staticClass:"text-xl lg:text-2xl 2xl:text-4xl",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.thirdTitle.text)}})]),_c('div',{staticClass:"container-components"},[_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.eigthParagraph.text)}})])],1)],1),_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                                icon: "diaporama",
                                collection:  [
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/dev_32_35_nam_theun_presentation.mp4",
                                        "type": "html5video",
                                        "caption": "Nam Theun 2 : présentation du projet",
                                        "thumb": _vm.getSpecificURL() + "fr/images/thumbs/developpement_france_et_inter/Nam_Theun_Mise.png", 
                                    },
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/dev_32_35_nam_theun_en_images.mp4",
                                        "type": "html5video",
                                        "caption": "Nam Theun 2 : mise en service de l’aménagement en 2009",
                                        "thumb": _vm.getSpecificURL() + "fr/images/thumbs/developpement_france_et_inter/NT-MiseEnService.jpg"
                                    },
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/dev_32_35_nam_theun_leau_du_reservoir.mp4",
                                        "type": "html5video",
                                        "caption": "Nam Theun 2 : le réservoir",
                                        "thumb": _vm.getSpecificURL() + "fr/images/thumbs/developpement_france_et_inter/IntroPhoto_NT_reservoir.jpg"
                                    },
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/diapositive_intro.png",
                                        "type": "image",
                                        "caption": "Nam Theun 2 : Album photos",
                                    },
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/diapositive1.jpg",
                                        "type": "image",
                                        "caption": "Nam Theun 2 : Album photos",
                                    },
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/diapositive2.jpeg",
                                        "type": "image",
                                        "caption": "Nam Theun 2 : Album photos",
                                    },
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/diapositive3.jpeg",
                                        "type": "image",
                                        "caption": "Nam Theun 2 : Album photos",
                                    },
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/diapositive4.jpeg",
                                        "type": "image",
                                        "caption": "Nam Theun 2 : Album photos",
                                    },
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/diapositive5.jpeg",
                                        "type": "image",
                                        "caption": "Nam Theun 2 : Album photos",
                                    },
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/diapositive6.jpeg",
                                        "type": "image",
                                        "caption": "Nam Theun 2 : Album photos",
                                    },
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/diapositive7.jpeg",
                                        "type": "image",
                                        "caption": "Nam Theun 2 : Album photos",
                                    },
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/diapositive8.jpeg",
                                        "type": "image",
                                        "caption": "Nam Theun 2 : Album photos",
                                    },
                                    
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/diapositive10.jpeg",
                                        "type": "image",
                                        "caption": "Nam Theun 2 : Album photos",
                                    },
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/diapositive11.jpeg",
                                        "type": "image",
                                        "caption": "Nam Theun 2 : Album photos",
                                    },
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/diapositive12.jpeg",
                                        "type": "image",
                                        "caption": "Nam Theun 2 : Album photos",
                                    },
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/diapositive13.jpeg",
                                        "type": "image",
                                        "caption": "Nam Theun 2 : Album photos",
                                    },
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/diapositive14.jpeg",
                                        "type": "image",
                                        "caption": "Nam Theun 2 : Album photos",
                                    },
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/diapositive15.jpeg",
                                        "type": "image",
                                        "caption": "Nam Theun 2 : Album photos",
                                    } ] 
                            }}}),_c('image-with-descriptions',{attrs:{"options":{
                        image:
                            'pages/' +
                            _vm.currentPage.slug +
                            '/' +
                            _vm.currentPage.images.image5.src,
                        descriptions: [
                            {
                                text: _vm.currentPage.images.image5.edf,
                                position: 'bottom-right', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            } ],
                    }}})],1),_c('div',{staticClass:"container-components"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-resolution_blue',
                            to: 'to-line',
                        }}},[_c('Triangles',{attrs:{"options":{
                            colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                            direction: 'top',
                        }}}),_c('span',{staticClass:"text-xl text-bold",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.fourthSubTitle.text)}})],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.seventhParagraph
                                    .text
                            )}})]),_c('div',{staticClass:"lg:w-1/2 lg:mx-auto"},[_c('image-with-descriptions',{attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.image6.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.image6.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1),_c('div',{staticClass:"card"},[_c('paragraph',{attrs:{"options":{
                                color: 'text-nandor',
                            }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                    _vm.currentPage.content.ninthParagraph.text
                                )}}),_c('Triangles',{attrs:{"options":{
                                    colors: [
                                        '#00357f',
                                        '#0b4f9c',
                                        '#0d94ff' ],
                                    direction: 'bottom',
                                }}})],1)],1)],1),_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                icon: "diaporama",
                collection:  [
                    {
                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/nam_theun_pv_flottant.mp4",
                        "type": "html5video",
                        "caption": "Nam Theun PV Flottant",
                        "thumb": _vm.getSpecificURL() + "fr/images/thumbs/developpement_france_et_inter/Nam_Theun_PV_Flottant.png"
                    }
                ] 
            }}}),_c('image-with-descriptions',{attrs:{"options":{
                        image:
                            'pages/' +
                            _vm.currentPage.slug +
                            '/' +
                            _vm.currentPage.images.image7.src,
                        descriptions: [
                            {
                                text: _vm.currentPage.images.image7.edf,
                                position: 'bottom-right', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            },
                            {
                                text: _vm.currentPage.images.image7.alt,
                                position: 'top-left', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            } ],
                    }}})],1),_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                icon: "diaporama",
                collection:  [
                    {
                        "src": _vm.getSpecificURL() + "fr/richmedia/page-012/dev_32_35_nam_theun_la_gestion_de_leau_linternational.mp4",
                        "type": "html5video",
                        "caption": "Nam Theun 2 : la gestion de l’eau",
                        "thumb": _vm.getSpecificURL() + "fr/images/thumbs/developpement_france_et_inter/NT-Gestion.jpg"
                            }
                        ] 
                    }}}),_c('div',{staticClass:"relative w-full h-full my-5 bg-black overflow-hidden"},[_c('image-with-descriptions',{staticClass:"opacity-100 lg:opacity-80 object-cover",staticStyle:{"margin":"0"},attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.image8.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.image8.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}})],1),_c('div',{staticClass:"q10__textInImage_3"},[_c('h2',{staticClass:"q10__title",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.fourthTitle.text)}}),_c('p',{staticClass:"q10__paragraph",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.tenParagraph.text)}})])],1),_c('div',{staticClass:"container-components"},[_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                            icon: 'diaporama',
                            collection: _vm.getRichmediaByCollection(
                                _vm.currentPage,
                                'Cameroun : projet Nachtigal'
                            ),
                        }}}),_c('image-with-descriptions',{staticClass:"relative",staticStyle:{"margin":"0","margin-bottom":"1.25rem"},attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.image9.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.image9.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}})],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-resolution_blue',
                            to: 'to-line',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                direction: 'top',
                            }}}),_c('span',{staticClass:"text-xl text-bold",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.fifthSubTitle.text)}})],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.eleventhParagraph.text)}}),_c('Triangles',{attrs:{"options":{
                                colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                direction: 'bottom',
                            }}})],1),_c('div',{staticClass:"relative"},[_c('image-with-descriptions',{staticClass:"relative",attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.image10.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.image10.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1)],1),_c('div',{staticClass:"card break-inside-avoid",staticStyle:{"padding-top":"0"}},[_c('image-with-descriptions',{staticClass:"relative eliminate-margin",attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.image11.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.image11.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                                {
                                    text: _vm.currentPage.images.image11.alt,
                                    position: 'top-left', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}}),_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-resolution_blue',
                            to: 'to-line',
                        }}},[_c('span',{staticClass:"text-xl text-bold",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sixthSubTitle.text)}}),_c('Triangles',{attrs:{"options":{
                                colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                direction: 'top',
                            }}})],1),_c('div',{staticClass:"container-components"},[_c('paragraph',{attrs:{"options":{
                                color: 'text-nandor',
                            }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                    _vm.currentPage.content.twelveParagraph.text
                                )}})])],1)],1),_c('div',{staticClass:"card",staticStyle:{"padding-top":"0"}},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-resolution_blue',
                            to: 'to-line',
                        }}},[_c('span',{staticClass:"text-xl text-bold",domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.seventhSubTitle.text
                            )}})]),_c('div',{staticClass:"container-components"},[_c('paragraph',{attrs:{"options":{
                                color: 'text-nandor',
                            }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                    _vm.currentPage.content.thirdteenParagraph
                                        .text
                                )}})])],1)],1),_c('div',{staticClass:"card",staticStyle:{"padding-top":"0"}},[_c('article-note',{staticClass:"eliminate-margin",attrs:{"options":{
                            verticalcontent:
                                _vm.currentPage.content.verticalText.text,
                            content:
                                _vm.currentPage.content.authorDescription.text,

                            color: {
                                verticalcontent: 'text-cornflower_blue',
                                content: 'text-nandor',
                            },
                            fontSize: {
                                verticalcontent: 'text-4xl lg:text-2xl',
                                content: '',
                            },

                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.image12.src,

                            descriptions: [
                                {
                                    text: _vm.currentPage.images.image12.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}})],1)])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }